import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useMasterLecturer = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [lecturerList, setLecturerList] = useState<any[]>();
  const [summary, setSummary] = useState<any[]>();
  const [total, setTotal] = useState<any>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const today = new Date();
  const default_start_date = today.getFullYear().toString() + '-01';
  const default_end_date = today.getFullYear().toString() + '-12';

  const { isLoading, refetch } = useQuery(
    [endpoints.master.sale.lecture.list, [location.search]],
    () =>
      fetcher.master.postMasterLecturrList({
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : default_start_date,   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : default_end_date,         
      }),
    {
      onSuccess: (res: MasterLecturResDto) => {
        switch (res.code) {
          case 200:
            setLecturerList(res.result?.list);
            setSummary(res.result?.summary);            
            setTotal(res.result?.total);            
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { lecturerList, summary, total, isLoading, refetch };
};

export default useMasterLecturer;
